import BaseChallengeAwardedPlaceService from 'services/challenge/awardedPlace/BaseChallengeAwardedPlaceService';

import ChallengeUserContainerAwardedPlace from 'models/challenge/awardedPlace/ChallengeUserContainerAwardedPlace';

export default class ChallengeSubmissionAwardedPlaceService extends BaseChallengeAwardedPlaceService {
	toModel(awardedPlace) {
		return new ChallengeUserContainerAwardedPlace(super.toModel(awardedPlace));
	}
}
